export default __webpack_public_path__ + "static/media/discounttable.cf5ef2a5.png";